@if ((authService.authenticated | async) === true) {
<flex-column adEl [gap]="0">
  <mat-toolbar adEl="header" color="primary" style="margin-bottom: 0">
    <flex-row adEl [gap]="16" [alignCenter]="true" grow>
      <a
        adEl="logo"
        routerLink="/home"
        style="color: inherit; text-decoration: none"
      >
        <span adEl>Apex&nbsp;</span>
        <span adEl style="color: #513bb3">Designer</span>
        <span
          adEl
          style="
            font-size: 11px;
            font-weight: 600;
            color: #4ad9ff;
            vertical-align: super;
            margin-left: 2px;
          "
          >3</span
        >
      </a>
      <span adEl grow></span>
      <avatar adEl [menuItems]="avatarMenuItems"></avatar>
    </flex-row>
  </mat-toolbar>
  <flex-row adEl grow [gap]="0">
    <ribbon adEl></ribbon>
    <div adEl grow style="padding: 16px 16px 0 8px; overflow: auto">
      <router-outlet adEl></router-outlet>
    </div>
  </flex-row>
  <mat-toolbar
    adEl="footer"
    color="primary"
    style="font-size: 12px; min-height: 32px; height: 32px"
    >Version {{packageService.version}}</mat-toolbar
  >
</flex-column>
} @if ((authService.authenticated | async) === false) {
<marketing-layout adEl></marketing-layout>
}
